export default __webpack_public_path__ + "ed5d6397e6dd5a40f4f399bbf4b98fe4.png";